<style lang="scss">
$leftWidth: 220px;
.goods-check-page {
  .el-form-item__content, .el-form-item__label {
    line-height: 24px !important;
  }

  .el-form-item__label {
    line-height: 24px !important;
  }

  .content-part {
    .el-form-item {
      margin-bottom: 0px;

      &__label {
        line-height: 24px;
      }
    }

    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .level-pic {
    margin-top: 16px;
    margin-left: 40px;
    margin-right: 20px;
    margin-bottom: 16px;
    background: #eee;
    min-height: 160px;
    padding-top: 40px;
    position: relative;

    &-li {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &-title {
      line-height: 22px;
      padding-left: 12px;
    }
  }

  .level-table {
    margin-right: 20px;
    margin-left: 40px;

    .el-input__inner {
      height: 22px;
    }
  }
}
</style>
<template>
  <div class="goods-check-page">
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>查看</h3>
        <div class="hide-content show-content" v-if="form">
          <el-form ref="form" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item style="line-height: 24px !important;" label="货品ID" prop="goodsName">
              {{ form.goodsId }}
            </el-form-item>
            <el-form-item style="line-height: 24px !important;" label="货品名称" prop="goodsName">
              {{ form.productName }}
            </el-form-item>
            <el-form-item label="子类编码" prop="productSubclassCode">
              {{ form.productSubclassCode }}
            </el-form-item>
            <el-form-item label="操作单位" prop="orgName" v-show="platform">
              {{ form.orgName }}
            </el-form-item>
            <el-form-item label="剂型" prop="productDosage">
              {{ form.productDosage }}
            </el-form-item>
            <el-form-item label="制剂规格" prop="productSpecification">
              {{ form.productSpecification }}
            </el-form-item>
            <el-form-item label="包装规格" prop="productPackingSpecification">
              {{ form.productPackingSpecification }}
            </el-form-item>
            <el-form-item label="包装单位" prop="productPackingUnit">
              {{ form.productPackingUnit || '暂无' }}
            </el-form-item>
            <el-form-item label="包装比例" prop="packingRatio">
              {{ (tabledatas && tabledatas.length > 0) ? tabledatas[0].packageRatio || '暂无' : '暂无' }}
            </el-form-item>
            <el-form-item label="申请时间" prop="createTime">
              {{ form.createTime | time }}
            </el-form-item>
            <el-form-item label="状态" prop="taskStatus" v-if="">
              {{
                this.$parent.$parent.stateOptions.find(f => f.value === form.taskStatus) && this.$parent.$parent.stateOptions.find(f => f.value === form.taskStatus).label || ''
              }}
            </el-form-item>
            <el-form-item label="下载次数" prop="downloadCount">
              {{ form.downloadCount }}
            </el-form-item>
          </el-form>
        </div>

        <div class="level-pic" :style="{height: (60 + (newTableData.length + 1) * 25) + 'px'}"
             v-if="newTableData && newTableData.length > 0">
          <div class="level-pic-li" :style="{
              zIndex: index,
              width: (60 + (newTableData.length - index + 1) * 25) + 'px',
              height: (60 + (newTableData.length - index + 1) * 25) + 'px',
              background: colorList[index]
            }" v-for="(item, index) in newTableData" :key="index">
            <div class="level-pic-title">
              {{ item.packingCount + item.packingUnit }}
            </div>
          </div>
        </div>

        <div class="level-table" v-if="newTableData && newTableData.length > 0">
          <el-table :data="newTableData" border>
            <el-table-column label="包装级别" prop="packingLevel">
            </el-table-column>
            <el-table-column label="每级件数" prop="packingCount">
            </el-table-column>
            <el-table-column label="追溯码数量">
              <template slot-scope="scope">
                {{ scope.row.applyCount }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http, goodsManage} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import platform from "@/components/goods/platform";

export default {
  props: {
    defaultIndex: Number,
    title: String,
    platform: {
      type: Boolean,
      default: false
    },
    form: Object,
    tabledatas: Array
  },
  mixins: [methodsMixin],
  data() {
    return {
      orgRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      platformRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        orgId: {required: true, message: '请选择操作单位', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null
    };
  },
  computed: {
    newTableData() {
      return this.tabledatas
          .sort((a, b) => {
            return b.packingLevel - a.packingLevel
          })
    },
    colorList() {
      return this.$store.state.colorList;
    },
    currentGoods() {
      return this.manageGoods.filter(f => f.goodsId === this.form.goodsId)[0] || {};
    },
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    },
    rules() {
      return this.platform ? this.platformRules : this.orgRules
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    },
  },
  methods: {
    handleTableAdd() {
    },
    handleTableDelete(scope) {
    },
    handleTableEdit(scope) {
    },
    setIsUploading(val) {
      this.isUploading = val;
    },
    onUploadProgress(file) {
      this.setIsUploading(false);
      this.uploadingFiles = file;
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = null;
    },
    queryGoodsBatchNumber(query) {
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')(query);
    },
    goodsChange(val) {
      this.form.batchNumberIdList = [];
      this.goodsBatchNumberList = [];
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        model: 0,

        orgId: '',

        productName: '',
        productPackingUnit: '',
        productRemark: '',

        productCode: '',
        productSubclassCode: '',
        productDosage: '',
        productSpecification: '',
        productPackingSpecification: ''
      };
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        this.doing = true;
        if (!this.platform) {
          this.form.orgId = this.$store.state.user.userCompanyAddress;
        }
        if (this.title === '新增') {
          goodsManage.goodsAdd(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        } else {
          goodsManage.goodsEdit(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        }
      });
    }
  }
};
</script>
